import {
  SimpleForm,
  SelectInput,
  useNotify,
  useRedirect,
  AutocompleteInput,
  usePermissions,
} from "react-admin";
import { apiUrl } from "../apiendpoint";

import {
  Card,
  CardContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";



import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { useGetList } from "react-admin";

const AssessmentAssignCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const { permissions = [] } = usePermissions();

  const [users, setUsers] = useState([]);
  const { data: assessments = [] } = useGetList("assessments");

  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedAssessmentId, setSelectedAssessmentId] = useState(null);
  const canCreate =
    permissions.includes("assessment.create") ||
    permissions.includes("assessment.*") ||
    permissions.includes("*");

  /* 🔹 Load users */
  useEffect(() => {
    fetch(`${apiUrl}user/all`)
      .then((res) => res.json())
      .then((data) => {
        setUsers(
          data.map((u) => ({
            id: u.id,
            name: `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.email,
          }))
        );
      })
      .catch(() => notify("Failed to load users", { type: "error" }));
  }, [notify]);

  /* 🔹 Load assessments */


  const [inputKey, setInputKey] = useState(0);

const addUser = () => {
  if (!selectedUserId) {
    notify("Select a user", { type: "warning" });
    return;
  }

  if (selectedUsers.includes(selectedUserId)) {
    notify("User already added", { type: "warning" });
    return;
  }

  setSelectedUsers((prev) => [...prev, selectedUserId]);

  setSelectedUserId(null);

  //  FORCE CLEAR UI
  setInputKey((prev) => prev + 1);
};
  /* 🔹 Remove user */
  const removeUser = (id) => {
    setSelectedUsers((prev) => prev.filter((u) => u !== id));
  };

  /* 🔹 Submit */
  const handleSubmit = async (values) => {
    try {
      if (!selectedUsers.length) {
        notify("Add at least one user", { type: "warning" });
        return;
      }

      const token = localStorage.getItem("access_token");

      const res = await fetch(`${apiUrl}assignments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          assessment_id:selectedAssessmentId,
          user_ids: selectedUsers,
        }),
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || "Failed");
      }

      notify("Assessment assigned successfully 🎉", {
        type: "success",
      });

      redirect("/assignments");
    } catch (err) {
      notify(err.message, { type: "error" });
    }
  };

  if (!canCreate) return null;

  return (
    <Card>
      <CardContent>
        <SimpleForm onSubmit={handleSubmit}>
          
          {/* 🔹 Select Assessment */}
<AutocompleteInput
  source="assessment_select"
  label="Assessment"
  choices={assessments.map((a) => ({
    id: a.id,
    name: a.title,
  }))}
  optionText="name"
  optionValue="id"
  value={selectedAssessmentId}
  onChange={(value) => setSelectedAssessmentId(value)}
  fullWidth
/>
          <Typography variant="h6" sx={{ mt: 2 }}>
            Add Users
          </Typography>

          <Grid container spacing={2} width="100%"alignItems="center" display={"flex"} justifyContent={"space-between"}flexDirection={"row"}>
            <Grid item xs={10} width="95%">
              <AutocompleteInput
                key={inputKey}
                source="user_select"
                label="User"
                choices={users}
                optionText="name"
                optionValue="id"
                value={selectedUserId}
                onChange={(value) => setSelectedUserId(value)}
                fullWidth
              />
            </Grid>

            <Grid item xs={2}>
              <IconButton color="primary" onClick={addUser}>
                <AddIcon />
              </IconButton>
            </Grid>
          </Grid>

          {/* 🔹 Selected Users List */}
          {selectedUsers.map((id) => {
            const user = users.find((u) => u.id === id);
            return (
              <Grid
                container
                spacing={2}
                alignItems="center"
                key={id}
                sx={{ mt: 1 }}
              >
                <Grid item xs={10}>
                  {user?.name || id}
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    color="error"
                    onClick={() => removeUser(id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Grid>
              </Grid>
            );
          })}
        </SimpleForm>
      </CardContent>
    </Card>
  );
};

export default AssessmentAssignCreate;